module.exports = __webpack_public_path__ + "static/media/icon_social-twitter.13245ce4.svg";